import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { ConfigService } from '../commons';
import { GenericResponse, AvisosList } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class RiskWarningService {
  riskList = new BehaviorSubject<GenericResponse>(null);

  constructor(private http: HttpClient, private config: ConfigService) {}

  getWarningsList() {
    return this.http.get<GenericResponse>(this.config.getUrl('grandesCuentas.getAvisosRiesgo')).pipe(
      tap((res: GenericResponse) => {
        this.riskList.next(res);
      })
    );
  }
}
